import React, {useMemo, useState} from 'react';
import {getClassList} from "../../../../Utility/siteConfig";
import CatchErrors from "../../../../Utility/CatchErrors";
import ItemClusterImages from "../image_display/ItemClusterImages";
import ItemClusterMain from "./ItemClusterMain";
import ClusterAddToCart from "../cart_display/ClusterAddToCart";
import {camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";

/**
 * 2025-10 ClusterAddToCart and below modernized, all tailwind, props fully camelized.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ItemClusterUi({allProductSpecs = [], productAttributes, ...props}) {
  // , products, itemCache, cartItem, sectionConfig, productAttributes
  const {cluster, clusterState, shoppingCart, cartItem, products, selectedItem, itemCache} = props;

  const camelizedProducts = useMemo(
    () => camelizeKeysDeep(products), [products]
  );

  const className = getClassList({
    key: 'ItemCluster',
    base: [
      'item-cluster lg:grid lg:grid-cols-12 py-8 border-solid border-b border-gray-200',
      clusterState.highlighted ? 'item-cluster-highlighted' : null,
    ],
    fallback: ""
  });
  // FIXME: css classes item-cluster item-cluster-highlighted

  // cluster.id like front_row_neosupreme_seat_covers
  return <div>
    <div className={className} id={"item-cluster-" + cluster.id}>
      <div className="lg:col-span-4 min-h-4 ">
        <CatchErrors><ItemClusterImages
          product={selectedItem?.product}
          products={products}
          itemCache={itemCache}
          clusterState={clusterState}
        /></CatchErrors>
      </div>
      <div className="lg:col-span-5 min-h-4 lg:px-4">
        <CatchErrors><ItemClusterMain
          cluster={cluster}
          clusterState={clusterState}
          itemCache={itemCache}
          productAttributes={productAttributes}
          allProductSpecs={allProductSpecs}
        /></CatchErrors>
      </div>
      <div className="lg:col-span-3 min-h-4">
        <CatchErrors><ClusterAddToCart
          clusterState={clusterState}
          products={camelizedProducts}
          shoppingCart={shoppingCart}
          cartItem={cartItem}
        /></CatchErrors>
      </div>
    </div>

  </div>
}



